import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  Injectable,
} from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  provideNativeDateAdapter,
  NativeDateAdapter,
  DateAdapter,
} from '@angular/material/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { FilterBarConfig } from '../../../interfaces/restaurant-shared.interface';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs);

// Custom DateAdapter to set Monday as first day of week

@Injectable()
class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1; // Monday (0 = Sunday, 1 = Monday, etc.)
  }
}

// Define custom date formats
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-restaurant-filter-bar',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginatorModule,
    FormsModule,
  ],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
  ],
  templateUrl: './restaurant-filter-bar.component.html',
  styleUrls: ['./restaurant-filter-bar.component.css'],
})
export class RestaurantFilterBarComponent {
  @Input() config: FilterBarConfig = {
    hasSearch: true,
    searchPlaceholder: 'Buscar...',
    hasBackButton: false,
    backButtonText: 'Volver',
    hasDateRange: true,
    filters: [],
    paginatorOptions: [25, 50, 100],
  };

  @Input() selectedFilter: string = '';
  @Input() searchText: string = '';
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;

  @Output() searchChange = new EventEmitter<string>();
  @Output() filterChange = new EventEmitter<string>();
  @Output() dateRangeChange = new EventEmitter<{
    startDate: Date | null;
    endDate: Date | null;
  }>();
  @Output() backClick = new EventEmitter<void>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchText = input.value;
    this.searchChange.emit(this.searchText);
  }

  selectFilter(filter: string): void {
    this.selectedFilter = filter;
    this.filterChange.emit(filter);
  }

  onDateRangeChange(startDate: Date | null, endDate: Date | null): void {
    this.startDate = startDate;
    this.endDate = endDate;
    this.dateRangeChange.emit({ startDate, endDate });
  }

  onBackClick(): void {
    this.backClick.emit();
  }

  getPaginator(): MatPaginator {
    return this.paginator;
  }
}
